import { Chip } from '@material-ui/core';

interface RecipientProps {
  domesticCoordinator: boolean,
  examTaskGroupCoordinator: boolean,
  examiningTeamChairman: boolean,
  techAdmin: boolean
}
const style = {
  margin: '5px',
  height: '25px',
  color: '#2C2D3E',
  backgroundColor: 'white',
  border: 'solid 1px rgba(44, 45, 62, 0.3)',
  fontWeight: 400,
  size: '12px',
  lineHeight: '20px',
};
export const RecipientsChips: React.FC<RecipientProps> = ({ domesticCoordinator, examTaskGroupCoordinator, examiningTeamChairman, techAdmin }) => {
  return (
    <>
      {domesticCoordinator && <Chip key={'KK'} style={style} variant="outlined" label={'KK'} />}
      {examTaskGroupCoordinator && <Chip key={'KGZ'} style={style} variant="outlined" label={'KGZ'} />}
      {examiningTeamChairman && <Chip key={'PZE'} style={style} variant="outlined" label={'PZE'} />}
      {techAdmin && (
        <Chip key={'techAdmin'} style={style} variant="outlined" label={'Administrator Techniczny'} />
      )}
    </>
  );
};
